import { ScrollText } from "lucide-react";
import { AdminEmptyState, AdminPageHeader } from "@/components/shell/AdminPage";

/**
 * Placeholder — account-level audit log UI deferred.
 * KB page version history remains at `/accounts/:id/kb/audit`.
 */
export default function AccountAuditLogPage() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="审计日志"
        description="账户级操作与变更记录。功能稍后实现。"
      />
      <AdminEmptyState>
        <div className="mx-auto flex max-w-md flex-col items-center gap-3">
          <ScrollText className="size-8 text-muted-foreground/70" />
          <p>
            审计日志即将上线。当前可在企业知识库内查看页面版本（知识库 · 审计 / 版本）。
          </p>
        </div>
      </AdminEmptyState>
    </div>
  );
}
